export default {
  labelLancamentoMastiteLote: 'Mastitis Batch Launch',
  selecioneTratamento: 'Select the treatment',
  selecioneBacteria: 'Select the bacteria',
  selecioneTipoMastite: 'Select the type of mastitis',
  selecioneCuraClinica: 'Select the clinical cure',
  selecioneGrau: 'Select the grade',
  selecioneTipoResultado: 'Select the type of result',
  labelRetornar: 'Return',
  labelTipoLeitura: 'Type Reading',
  labelAcoes: 'Actions',
  btnResultados: 'Results',
  btnFichaVaca: 'Cow Sheet',
  btnTratamentos: 'Treatments',
  btnRelatorios: 'Reports',
  labelParabens: 'Congratulations, you are',
  labelEconomizando: 'saving!',
  btnSaibaMais: 'Learn More',
  labelLojaOnfarm: 'Onfarm Store',
  labelDescricaoLojaOnfarm: 'What is the Onfarm Store and',
  labelBeneficiosLojaOnfarm: 'what benefits does it bring',
  labelVoceTem: 'You have',
  btnAcessarLoja: 'Access Store',
  btnLancamento: 'Launch',
  labelResultados: 'Results',
  labelQuarto: 'Udder Quarter',
  labelTarefas: 'Tasks',
  labelFiltrar: 'Filter',
  labelPesquisar: 'Search',
  labelBrinco: 'ID',
  labelData: 'Date',
  labelTipo: 'Type',
  labelTratamentos: 'Treatment',
  labelLeituraResultados: 'Reading Results',
  labelResultado: 'Result',
  labelCuraClinica: 'Clinical Cure',
  labelVoceEconomizou: 'You saved',
  labelMinhasTarefas: 'My Tasks',
  labelLancamentosRapidos: 'Quick Releases',
  btnLancarMastite: 'Launch mastitis',
  labelUsuario: 'User',
  login_labelDigiteNomeUsuario: 'Enter the username',
  labelSenha: 'Password',
  login_labelDigiteSuaSenha: 'Enter your password',
  login_labelEsqueciMinhaSenha: 'Forgot my password',
  login_btnEntrar: 'LOGIN',
  login_btnEntrando: 'LOGGING IN...',
  login_returnCamposUsuarioObrigatorio: 'Username and password fields are mandatory!',
  login_returnDefinirNovaSenha: 'A new password must be set.',
  forgotPassword_labelUsuario: 'User',
  forgotPassword_labelDigiteNomeUsuario: 'Enter the username',
  forgotPassword_labelSelecioneReceberSenhaTemporaria: 'A temporary password will be sent via WhatsApp.',
  forgotPassword_btnEnviar: 'SEND',
  forgotPassword_btnEnviando: 'SENDING...',
  forgotPassword_returnNecessarioSelecionarOpcao: 'It is necessary to select an option!',
  forgotPassword_returnCampoUsuarioObrigatorio: 'Username field is mandatory!',
  forgotPassword_returnFoiEnviadoSenhaTemporaria: 'A temporary password has been sent via',
  forgotPassword_returnFacaLogin: 'Log in',
  labelBemVindo: 'Welcome',
  labelSelecioneFazendaAvancar: 'Select the farm to proceed',
  farm_labelPesquiseFazenda: 'Search for a farm',
  farm_btnProsseguir: 'Proceed',
  labelAjuda: 'Help',
  footer_btnInicio: 'Home',
  labelNovoUsuario: 'New User',
  footer_btnNotificacao: 'Notification',
  homeBezerra_labelTitulo: 'Calf Health',
  homeBezerra_btnIrparaLoja: 'Go to store',
  homeBezerra_btnMinhasTarefas: 'My tasks',
  homeBezerra_btnBancoColostro: 'Colostrum Bank',
  homeBezerra_btnColostragem: 'Colostrum Management',
  homeBezerra_btnTratamentos: 'Treatments',
  homeBezerra_btnFichaBezerra: 'Calf Record',
  homeBezerra_btnDoencas: 'Diseases',
  labelGrafico: 'Charts',
  homeBezerra_btnRelatorio: 'Reports',
  homeBezerra_btnContato: 'Contact',
  homeBezerra_btnSincronizar: 'Synchronize',
  labelTop5IntramamarioAgentes: 'Products most used by the OnFarmers community',
  labelSelecioneAgentes: 'Select the agents',
  labelOnfarmersTop5IntramamarioATB: 'Top 5 - Intramammary Antibiotics',
  labelOnfarmersTop5InjetavelATB: 'Top 5 - Injectable Antibiotics',
  labelOnfarmersTop5AntiflamatorioATB: 'Top 5 - Anti-inflammatory Antibiotics',
  labelOnfarmersTop5IntramamariosAgentes: 'Top 5 - Intramammary Antibiotics by agents',
  labelOnfarmersDiasTratamentoIntramamariosAgentes: 'Days of intramammary antibiotic treatment by agent',
  labelOnfarmersCuraClinica: 'Clinical cure',
  labelMeusDados: 'My Data',
  labelDadosUsuario: 'User Data',
  labelDadosFazenda: 'Farm Data',
  labelAlterarSenha: 'Change password',
  labelMinhasContas: 'My Accounts',
  labelRastreioPedidos: 'Order Tracking',
  labelVacasLactacao: 'Lactating Cows',
  labelUsuarioFazendas: 'Users/Farms',
  labelUsuarios: 'Users',
  labelFazendas: 'Farms',
  labelAlternarFazenda: 'Change Farm',
  labelArtigosVideos: 'Articles and Videos',
  labelIntegracoes: 'Integrations',
  labelTokenOnfarm: 'OnFarm Token',
  labelParceiros: 'Partners',
  labelUtilidades: 'Utilities',
  labelRepararBancoDados: 'Repair Database',
  labelDiagnosticoAparelho: 'Device Diagnosis',
  labelDados: 'Data',
  labelExportarBancoDeDados: 'Export Database',
  labelCentralNotificacao: 'Notification Center',
  labelSair: 'Log Out',
  homeUbere_btnIrParaLoja: 'Go to Store',
  homeUbere_btnMInhasTarefas: 'My Tasks',
  homeUbere_btnFichaVaca: 'Cow Record',
  homeUbere_btnTratamentos: 'Treatments',
  btnGraficos: 'Charts',
  homeUbere_btnRelatorios: 'Reports',
  labelAnaliseCbtTanque: 'Tank TBC Analysis',
  homeUbere_btnContato: 'Contact',
  btnComunidadeOnfarmers: 'Community',
  homeUbere_btnSincronizar: 'Synchronize',
  homeUbere_btnRumiTank: 'Last Measurement',
  dadosUsuario_labelDadosUsuario: 'User Data',
  dadosUsuario_labelDadosFazenda: 'Farm Data',
  labelNome: 'Name',
  labelID: 'ID',
  labelLogin: 'Login',
  labelPerfil: 'Profile',
  labelEmail: 'Email',
  labelTelefone: 'Telephone',
  labelFazenda: 'Farm',
  labelIdioma: 'Language',
  labelAtivarPopupCuraClinica: 'Activate Clinical Cure Pop-up',
  labelAtivarPopupVacasLactacao: 'Activate Lactating Cows Pop-up',
  dadosUsuario_returnAtualizadoSucesso: 'Updated successfully!',
  labelAtualizar: 'Update',
  labelLaticinios: 'Dairy',
  labelNumVacasLactacao: 'Number of lactating cows',
  labelVolumeLeite: 'Milk volume (L/day)',
  labelSistemaProducao: 'Production system',
  labelCidade: 'City',
  labelEstado: 'State',
  labelOrganizacaoPrincipal: 'Main organization',
  alterarSenha_labelCriarNovaSenha: 'Create new password',
  alterarSenha_labelDigiteNovaSenha: 'Enter a new password',
  alterarSenha_labelConfirmarNovaSenha: 'Confirm new password',
  alterarSenha_labelConfirmeNovaSenha: 'Confirm your new password',
  alterarSenha_returnSenhaConfirmacaoSenhaObrigatorios: 'Password and password confirmation are required!',
  alterarSenha_returnMinimoDigitos: 'Minimum 6 digits',
  alterarSenha_returnSenhasDevemIguais: 'Passwords must be the same!',
  returnSenhaAlteradaSucesso: 'Password changed successfully!',
  alterarSenha_returnErroAlterarSenha: 'Error changing password!',
  alterarSenha_returnTenteNovamenteInstantes: 'Try again in a moment.',
  rastreioPedido_filtroEnviado: 'Sent',
  rastreioPedido_filtroAguardandoFaturamento: 'Foreseen',
  rastreioPedido_filtroAutorizado: 'Sent',
  rastreioPedido_filtroFaturado: 'Invoiced',
  rastreioPedido_filtroCancelado: 'Canceled',
  rastreioPedido_filtroDevolvido: 'Returned',
  rastreioPedido_filtroDevolvidoParcialmente: 'Partially Returned',
  rastreioPedido_filtroDenegado: 'Denied',
  rastreioPedido_filtroPrevisto: 'Foreseen',
  rastreioPedido_filtroEntregue: 'Delivered',
  labelPedido: 'Order',
  rastreioPedido_colStatus: 'Status',
  rastreioPedido_colData: 'Date',
  rastreioPedido_filtroPedido: 'Order',
  rastreioPedido_filtroStatus: 'Status',
  rastreioPedido_filtroDataVencimento: 'Due date',
  rastreioPedido_filtroFILTRAR: 'FILTER',
  labelPeriodo: 'Period',
  vacaLactacao_colQuantidade: 'Quantity',
  vacaLactacao_filtroQuantidade: 'Quantity',
  usuario_colUsuário: 'User',
  usuario_colPerfil: 'Profile',
  usuario_colFazenda: 'Farm',
  usuario_title: 'Users',
  usuario_filtoUsuario: 'User',
  usuario_returnCampoNomeObrigatorio: 'Name field is mandatory!',
  usuario_returnCampoLoginObrigatorio: 'Login field is mandatory!',
  usuario_returnSelecioneAoMenosUmPerfil: 'Select at least one profile!',
  usuario_returnSelecioneAoMenosUmaFazenda: 'Select at least one farm!',
  usuario_returnHabiliteAoMenosUmaPermissao: 'Enable at least one permission!',
  usuario_labelNome: 'Name',
  usuario_labelLogin: 'Login',
  labelPerfilUsuario: 'User Profile',
  usuario_labelFazendas: 'Farms',
  usuario_labelEmail: 'Email',
  usuario_labelTelefone: 'Telephone',
  labelPermissoesUsuario: 'User Permissions',
  usuario_returnEsteLoginJaExiste: 'This login already exists, please enter another one!',
  repararBD_returnRepararBanco: 'Repair Database',
  repararBD_returnApagandoBanco: 'Deleting Database...',
  repararBD_returnReparacaoConcluidaSucesso: 'Repair completed successfully',
  repararBD_returnReparando: 'Repairing...',
  repararBD_returnDesejaRealmenteAlternarFazenda: 'Do you really want to switch farms ? ',
  repararBD_returnDesejaRealmenteRepararBanco: 'Do you really want to repair the database?',
  repararBD_returnIssoPodeApagarTodosDados: 'This may delete all your data.',
  repararBD_returnAtencao: 'Attention!',
  repararBD_returnConstamDadosParaSincronizar: 'There are data to synchronize. Would you like to synchronize?',
  repararBD_returnIssoApagarTodosDados: 'This will delete all your data',
  export_labelExportBD: 'Database',
  export_labelTamBanco: 'Local database size',
  export_labelExportar: 'SEND COPY OF DATABASE',
  export_labelExportando: 'SENDING...',
  export_labelExportado: 'Sent',
  export_labelExportadocaoConcluida: 'Successfully completed sending!',
  export_labelExportadoModal: 'Sending',
  export_labelExportadoDescricaoModal: 'Sending copy of local database to server',
  labelNovaFazenda: 'New Farm',
  labelNomeProprietario: 'Owners Name',
  labelVideos: 'Videos',
  labelVideo: 'Video',
  labelArtigos: 'Articles',
  labelArtigo: 'Article',
  labelUbere: 'Udder',
  labelBezerra: 'Heifer',
  labelTitulo: 'Title',
  artigo_labelTipo: 'Type',
  labelCategoria: 'Category',
  labelTutorias: 'Tutorials',
  labelIdFazenda: 'id Farm',
  labelGerandoToken: 'Generating Token...',
  labelGerarToken: 'Generate Token',
  labelTokenGerado: 'Token Generated',
  diagnostico_labelDiagosticoAparelho: 'Device Diagnosis',
  diagnostico_labelArmazenamento: 'Storage',
  diagnostico_labelDoArmazenamento: 'of storage',
  diagnostico_labelMemoria: 'Memory',
  diagnostico_labelDaMemoriaRAM: 'from RAM',
  diagnostico_labelInternetWifi: 'Internet - WiFi',
  diagnostico_labelDoSinal: 'of the Sign',
  diagnostico_labelFabricanteModelo: 'Manufacturer/Model',
  diagnostico_labelPlataforma: 'Platform',
  notificacao_labelAtiveDesativeNotificacao: 'Enable or Disable Notifications',
  fichaVaca_labelInformaçãoSuplementar: 'Supplementary Information',
  fichaVaca_labelVolumeLeite: 'Milk Volume',
  fichaVaca_labelNumero: 'Number',
  fichaVaca_labelInibidorMicrobiologico: 'Microbiological Inhibitor',
  fichaVaca_labelMotivoDescarte: 'Reason for Discard',
  fichaVaca_labelGordura: 'Fat',
  fichaVaca_labelProteína: 'Protein',
  fichaVaca_labelLactose: 'Lactose',
  fichaVaca_labelSolidosTotais: 'Total solids',
  fichaVaca_labelCCS: 'SCC',
  fichaVaca_labelCCP: 'SPC',
  fichaVaca_labelNUreico: 'N Ureic',
  fichaVaca_labelCaseina: 'Casein',
  fichaVaca_labelCrioscopia: 'Cryoscopy',
  fichaVaca_labelAniversario: 'Birthday',
  fichaVaca_labelDataCCS: 'SCC date',
  fichaVaca_labelDataUltimoRegistroLeite: 'Date of Last Milk Record',
  fichaVaca_labelUltimoRegistroLeiteKg: 'Last Milk Record in Kg',
  fichaVaca_labelDataUltimoParto: 'Last Calving Date',
  fichaVaca_labelDataPrevistaSecagem: 'Expected Drying Date',
  fichaVaca_labelDEL: 'DIM',
  fichaVaca_labelDataProducaoLeite: 'Milk Production Date',
  fichaVaca_labelProducaoLeite: 'Milk Production',
  fichaVaca_labelDataMastite: 'Mastitis Date',
  fichaVaca_labelImportacao: 'Import',
  fichaVaca_labelNdeCasos: 'Number of Clinical Cases',
  tratamento_returnCampoDescricaoObrigatorio: 'Description field required',
  tratamento_returnSelecioneUmTipoMastite: 'Select a type of mastitis',
  tratamento_returnSelecioneUmGrau: 'Select the severity',
  tratamento_returnSelecioneUmaObservacao: 'Select an observation',
  tratamento_returnSelecioneUmResultado: 'Select a Result',
  tratamento_returnSelecionePeloMenosUmaBacteria: 'Select at least one bacteria',
  tratamento_returnSelecioneUmOpcaoAtivo: 'Select an option in active',
  tratamento_returnSalvoComSucesso: 'Saved successfully',
  returnDesejaMesmoSalvarEsteTratamento: 'Do you really want to save this treatment',
  tratamento_labelEditarTratamento: 'Edit treatment',
  tratamento_labelNovoTratamento: 'New treatment',
  labelDescricao: 'Description',
  labelCodigoIntegracaoIdeagri: 'ideagri Integration Code',
  labelTipoMastite: 'Mastitis Type',
  tratamento_labelGrau: 'Severity',
  tratamento_labelEscoredeChancedeCura: 'Chance of Cure Score',
  tratamento_labelObservação: 'Observation',
  labelAntibioticoInjetavel: 'Injectable antibiotic',
  tratamento_labelSelante: 'Sealant',
  tratamento_labelAtivo: 'Active? ',
  tratamento_labelAtualizarProtocolo: 'UPDATE PROTOCOL',
  tratamento_labelAdicionarProtocolo: 'ADD PROTOCOL',
  tratamento_labelDigiteValorValido: 'Enter Valid value',
  tratamento_labelBaixo: 'Low',
  tratamento_labelMédio: 'Medium',
  tratamento_labelAlto: 'High',
  labelLeve: 'Mild',
  labelModerado: 'Moderate',
  labelGrave: 'Severe',
  tratamento_labelCSSAlta: 'SCC high',
  labelManha: 'Morning',
  labelTarde: 'Afternoon',
  labelNoite: 'Night',
  labelRepetirEsteMedicamento: 'Repeat this medicine during the day during periods',
  tratamento_labelPesquiseProdutos: 'Search products',
  tratamento_labelPesquise: 'Search',
  labelAdicionarMedicamento: 'Add Medication',
  tratamento_returnDigiteNomePesquisa: 'Enter name in the search field',
  labelSelecioneBacterias: 'Select the bacteria',
  tratamento_labelPesquiseBacteria: 'Search for the bacteria...',
  home_labelVoceEconomizouAteMomento: 'You saved up to now',
  labelOcorrenciaMastiteClinica: 'Clinical Mastitis Occurrence',
  labelIncidenciaMastiteClinica: 'Incidence of Clinical Mastitis',
  labelAgentesCausadoresMastite: 'Mastitis-causing agents',
  labelPrevalenciaGrupoGRAM: 'Prevalence by GRAM group',
  labelCuraClinicaDiagnóstico: 'Clinical cure by diagnosis',
  labelConsolidadoDiagnostico: 'Consolidated - Diagnostics',
  labelCasosMastiteTratamento: 'Mastitis cases and treatments per day',
  labelConsolidadoDiagnosticoTratamento: 'Consolidated - diagnoses, treatments and clinical cure',
  labelExportacaoIdeagri: 'Export - Ideagri',
  labelExportacaoACL: 'Export - ACL',
  tanque_labelAnaliseCBTTanque: 'TBC Tank Analysis',
  labelTanque: 'Tank',
  tanque_labelData: 'Date',
  tanque_labelCCS: 'SCC',
  tanque_labelCBT: 'TBC',
  tanque_labelNovoTanque: 'New Tank',
  tanque_labelDescricao: 'Description',
  labelVolume: 'Volume',
  labelProteina: 'Protein',
  tanque_labelDigiteDescricao: 'Enter the description',
  tanque_labelDigiteVolume: 'Enter the volume',
  tanque_labelDataColeta: 'Collection date',
  labelGordura: 'Fat',
  tanque_labelLERCODIGODEBARRAS: 'Read TBC Code',
  tanque_labelDigiteProteina: 'Enter the protein',
  tanque_labelDataLancamento: 'Release date',
  tanque_labelCampoDescricaoNaoPreenchido: 'Description field not filled',
  labelEssaPlacaJaFoiUtilizada: 'This Plate has already been used',
  tanque_labelValidando: 'Validating...',
  tanque_labelSalvarNovoTanque: 'SAVE NEW TANK',
  tanque_labelTanqueNaoConstaFotoServidor: 'Tank has no photo on the server',
  labelAjudaGuiaCores: 'Color Guide Help',
  labelContagemColonias: 'Colony count',
  labelManual: 'Manual',
  labelAutomatico: 'Automatic',
  labelNumColonias: 'Number of colonies',
  labelDiluicao: 'Dilution',
  labelCBTest: 'TBCTest',
  labelAtualizarTanque: 'UPDATE TANK',
  labelEmAnalise: 'Under analysis',
  returnTanqueAtualizandoComSucesso: 'Tank successfully updated!',
  tanque_labelCampoTipoContagem: 'Select counting type!',
  boasVindas_textTexto001: 'WELCOME!',
  boasVindas_textTexto002: "Hi, I'm'",
  boasVindas_textTexto003: 'Welcome to the New OnfarmApp!',
  boasVindas_textTexto004: "While you wait for synchronization, here's a tip from the New OnFarmApp",
  boasVindas_textTexto005: 'Here you will also have Rumi, our artificial intelligence.',
  boasVindas_textTexto006: 'activated',
  boasVindas_textTexto007: 'and will continue to do its job every time you need to read a result on the plate or analyze the chance of cure scores for clinical mastitis cases.',
  boasVindas_textTexto008: 'VISIT MY PAGE',
  colostro_labelLote: 'Batch',
  colostro_labelData: 'Date',
  colostro_labelVolume: 'Volume',
  colostro_labelBrix: 'Brix',
  colostro_labelCBT: 'TBC',
  colostro_labelBancoColostro: 'Colostrum Bank',
  colostro_labelBrincoBezerra: 'Calf Tag',
  colostro_labelDigiteUmLote: 'Enter a batch',
  colostro_labelBrixColostro: 'Colostrum Brix',
  returnColostroAtualizadoSucesso: 'Colostrum updated successfully!',
  colostro_returnAdicioneBrinco: 'Add ID',
  colostro_returnAdicioneAoMenosUmPacote: 'Add at least one package',
  colostro_returnPorFavorAnexeUmaImagem: 'Please attach an image',
  returnFavorAguardeProcessamentoAutomatico: 'Please wait for automatic processing',
  colostro_returnErroProcessarImagemTireUmaNovaFoto: 'Error processing image. Take a new photo and try again!',
  colostro_btnEditarColostro: 'Edit colostrum',
  colostro_btnNovoColostro: 'New colostrum',
  colostro_labelVaca: 'Cow',
  colostro_labelDensidadeColostometro: 'Density (Colostometer)',
  colostro_btnSALVARCOLOSTRO: 'SAVE COLOSTRUM',
  colostro_btnADICIONARCOLOSTRO: 'ADD COLOSTRUM',
  colostro_btnADICIONANDO: 'ADDING...',
  colostro_labelDataCongelamento: 'Freezing date',
  colostro_labelAdicioneQuantidadePacotesVolumesForamCongelados: 'Add the quantity of packages and volumes that were frozen',
  colostro_labelInsiraPacotesVolumes: 'Insert packages and volumes',
  colostro_labelPacotes: 'Packages',
  colostro_labelVolumeLPacotes: 'Volume(L/Packages)',
  colostro_labelAdicionarPacotesVolume: 'Add Packages and Volume',
  colostro_labelNumPacotes: 'No. of Packages',
  colostro_labelVolumePct: 'Package Volume',
  colostro_labelVolumeTotal: 'Total Volume',
  colostro_labelTotal: 'Total',
  colostro_labelEssaPlacaJaFoiUtilizada: 'This plate has already been used',
  colostro_labelLERCODIGOBARRAS: 'Read TBC Code',
  colostro_labelValidando: 'Validating...',
  lancBezerra_btnNovoColostro: 'New Colostrum',
  lancBezerra_btnNovaColostragem: 'New Colostrum',
  lancBezerra_labelLeituraResultados: 'Result Reading',
  colostragem_labelColostragem: 'Colostrage',
  colostragem_labelBrincoBezerra: 'Calf Tag',
  colostragem_labelLote: 'Batch',
  colostragem_labelDigiteUmLote: 'Enter a batch',
  colostragem_labelNascimento: 'Birth',
  colostragem_labelBrixColostro: 'Colostrum Brix',
  colostragem_labelCBT: 'TBC',
  colostragem_labelBrixSangue: 'Blood Brix',
  colostragem_labelBrix: 'Brix',
  colostragem_labelSangue: 'Blood',
  colostragem_labelEditarColostragem: 'Edit Colostrum',
  colostragem_labelNovaColostragem: 'New Colostrum',
  colostragem_labelProteinaSerica: 'Serum protein',
  colostragem_labelDataNascimento: 'Birth date',
  colostragem_labelVolume: 'Volume',
  colostragem_labelSelecioneColostro: 'Select the colostrum',
  colostragem_labelLoteNecessárioAdicionarNovoPacote: 'Batch is required to Add a new package',
  colostragem_labelAdicionarPacotes: 'Add Packages',
  colostragem_labelDesejaRealmenteExcluirEssePacote: 'Do you really want to delete this package?',
  colostragem_labelVolumeLPacotes: 'Volume(L/Packages)',
  colostragem_labelLoteNaoPodeSerVazio: 'Batch cannot be empty',
  colostragem_labelSALVARCOLOSTRAGEM: 'SAVE COLOSTRAGE',
  colostragem_labelPesoNascimento: 'Birth Weight',
  labelLoteNaoEncontrado: 'Batch not found',
  graficoBezerra_labelQualidadeColostroCBT: 'Colostrum Quality (TBC)',
  graficoBezerra_labelQualidadeColostroBRIX: 'Colostrum Quality (BRIX)',
  graficoBezerra_labelQualidadeColostroIgGCBT: 'Colostrum Quality (IgG and TBC)',
  graficoBezerra_labelQualidadeColostragem: 'Quality Colostrum',
  graficoBezerra_labelDoencas: 'Diseases',
  graficoBezerra_labelConsolidado: 'Consolidated',
  graficoBezerra_labelExportar: 'Generate report',
  novaHome_labelVerificandoConexao: 'Checking connection...',
  novaHome_labelAguardeEnquantoVerificamosSuaConexao: 'Please wait while we check your internet connection.',
  novaHome_labelBuscandoSinal: 'Searching for signal...',
  novaHome_labelRumiEstaOnline: 'Rumi is online!',
  novaHome_labelVocePodeContarRumiFazerLeituraAutomatica: 'You can rely on Rumi for automatic reading of diagnostics.',
  novaHome_labelFazerLeituraResultados: 'Read results',
  novaHome_labelRumiEstaOffline: 'Rumi is offline!',
  novaHome_labelVoceEstaSemConexaoInternet: 'You are without an internet connection and will only be able to perform manual readings.',
  novaHome_labelSincronizandoDados: 'Synchronizing Data...',
  novaHome_labelProgresso: 'Progress',
  novaHome_labelSincronizacaoDisponivel: 'Synchronization Available',
  novaHome_labelNovosDadosSincronizarServidor: 'new data to synchronize with the server',
  novaHome_labelSincronizarDadosAgora: 'Synchronize data now',
  novaHome_labelVoceJaEconomizou: "You've already saved",
  novaHome_labelSemConexaoComInternet: 'No internet connection',
  novaHome_labelTenteMaisTarde: 'Try later',
  novaHome_labelSemWhatsapp: 'No WhatsApp',
  novaHome_labelWhatsappNaoFoiEncontrado: 'Whatsapp was not found. Please install it and try again',
  novaHome_labelTarefasEmAberto: 'Open tasks',
  novaHome_labelVerTodas: 'View all',
  novaHome_labelNenhumaTarefaParaHoje: 'No tasks due today.',
  novaHome_labelIrParaSaudeBezerra: 'Go to Calf Health',
  sincronismo_labelCarregando: 'Loading...',
  sincronismo_labelPermissoes: 'Permissions',
  sincronismo_labelGrupos: 'Groups',
  sincronismo_labelTopicosAjuda: 'Help Topics',
  sincronismo_labelFabricantes: 'Manufacturers',
  sincronismo_labelProdutos: 'Products',
  sincronismo_labelAgentes: 'Agents',
  sincronismo_labelParametros: 'Parameters',
  sincronismo_labelAgentesParametros: 'Parameter Agents',
  sincronismo_labelCategoriasNotificacoes: 'Notification Categories',
  sincronismo_labelPreferenciasNotificacoes: 'Notifications preferences',
  sincronismo_labelCondicoesNotificacoes: 'Notification conditions',
  sincronismo_labelAnimais: 'Animals',
  sincronismo_labelFazendas: 'Farms',
  sincronismo_labelUsuarios: 'Users',
  sincronismo_labelVacasLactacao: 'Lactating Cows',
  sincronismo_labelProtocolos: 'Protocols',
  sincronismo_labelProtocolosProdutos: 'Protocols - Products',
  sincronismo_labelDiagnosticos: 'Diagnostics',
  sincronismo_labelTarefasProdutos: 'Tasks - Products',
  sincronismo_labelProtocolosDiagnosticos: 'Diagnostic Protocols',
  sincronismo_labelProtocolosProdutosDiagnosticos: 'Protocols - Diagnostic Products',
  sincronismo_labelAnaliseTanque: 'Tank Analysis',
  sincronismo_labelProtocolosBezerra: 'Calf Protocols',
  sincronismo_labelBezerraProtocolosProdutos: 'Calf Protocols - Products',
  sincronismo_labelDoencas: 'Diseases',
  sincronismo_labelTarefasBezerra: 'Calf Tasks',
  sincronismo_labelTarefasBezerraProdutos: 'Calf Tasks - Products',
  sincronismo_labelProtocolosDoencas: 'Disease Protocols',
  sincronismo_labelProtocolosProdutosDoencas: 'Protocols - Products - Diseases',
  sincronismo_labelBancoColostro: 'Colostrum Bank',
  sincronismo_labelColostragem: 'Colostrage',
  sincronismo_labelPacotesColostro: 'Colostrum Packets',
  sincronismo_labelColostragemColostro: 'Colostrage - Colostrum',
  sincronismo_labelParceiros: 'Partners',
  sincronismo_labelConfiguracoesParceiros: 'Partner settings',
  geral_labelDadosFazenda: 'Farm Data',
  labelSim: 'Yes',
  labelNao: 'No',
  btnSalvarAlteracao: 'SAVE CHANGE',
  labelSalvar: 'SAVE',
  labelSalvando: 'SAVING',
  geral_LabelFiltros: 'Filters',
  geral_LabelRemoverFiltros: 'Remove Filters',
  geral_returnSemConexaoInternet: 'No internet connection',
  geral_returnTenteMaisTarde: 'Try later',
  labelImportarDados: 'Import data',
  geral_btnAtualizar: 'UPDATE',
  geral_btnAtualizando: 'UPDATING...',
  geral_returnSalvoComSucesso: 'Saved successfully!',
  geral_returnSalvoComSucessoWhatshapp: 'The access data will be sent via WhatsApp to the provided phone contact.',
  geral_returnAtualizadoComSucesso: 'Updated successfully!',
  labelTodos: 'All',
  geral_returnEditadoComSucesso: 'Edited successfully!',
  geral_returnDesculpe: 'Sorry',
  geral_returnDesejaRealmenteSair: 'Do you really want to exit?',
  labelCancelar: 'Cancel',
  geral_btnConfirmar: 'Confirm',
  geral_labelDigiteAlgo: 'Type something',
  geral_returnSelecioneFazenda: 'Select a farm',
  geral_labelResultados: 'Results',
  labelGrau: 'Degree',
  geral_labelCuraClinica: 'Clinical cure',
  labelEditar: 'Edit',
  labelExcluir: 'Delete',
  geral_btnVisualizar: 'View',
  labelBacterias: 'Bacteria',
  geral_returnDesejaExcluirEsteDiagnostico: 'Do you want to exclude this diagnosis',
  labelFiltrarPor: 'Filter by',
  geral_labelDataInício: 'Start date',
  geral_labelDataFinal: 'Final date',
  labelVerMais: 'View more',
  labelRealizarLeitura: 'Perform reading',
  geral_labelMaiorQue: 'Bigger then',
  geral_labelMaiorIgualQue: 'Greater and equal to',
  geral_labelMenorQue: 'Less than',
  geral_labelMenorIgualQue: 'Less than and equal to',
  labelMastiteClinica: 'Clinical Mastitis',
  labelMastiteSubclínica: 'Subclinical Mastitis',
  labelMastiteSemCultura: 'Mastitis Without Culture',
  labelSecagem: 'Drying',
  labelPosTratamento: 'After treatment',
  labelPosParto: 'Post - partum',
  geral_labelFichaVaca: 'Cow Sheet',
  labelNumeroCaso: 'Nº Clinical Cases',
  geral_returnErroFazerUploadArquivo: 'Error uploading file!',
  geral_labelImportacaoDados: 'Data Import',
  geral_labelSincronizando: 'Synchronizing',
  geral_returnSelecioneUmParceiro: 'Select a partner',
  labelDownloadTemplate: 'Download Template',
  geral_returnProcessarImportacao: 'Process Import',
  geral_returnBaixandoArquivo: 'Downloading File',
  geral_returnWebArquivo: 'Download problem',
  geral_returnImportandoArquivo: 'Importing File',
  geral_returnSalvandoBibliotecaMídia: 'Saving to media library',
  geral_returnBaixandoWeb: 'The file download can be accessed via the web',
  geral_returnEnviandoDadoParaServidor: 'Sending data to server',
  labelAgentes: 'Agents',
  geral_labelSelante: 'Sealant',
  labelCompartilhar001: 'Share',
  geral_labelCopiar: 'Copy',
  labelStatus: 'Status',
  labelNovoTratamento: 'New Treatment',
  btnExameMicrobiologico: 'Microbiological Examination',
  btnNovaMastiteClinicaSemExame: 'New clinical mastitis WITHOUT Exam',
  geral_labelAnaliseCbtTanque: 'TBC Tank Analysis',
  geral_labelSaudeBezerra: 'Calf Health',
  geral_labelSaudeUbere: 'Udder Health',
  labelClinica: 'Clinical',
  labelSubclinica: 'Subclinical',
  labelSemCultura: 'No Culture',
  labelSemResultado: 'No results',
  labelNegativo: 'Negative',
  labelPositivo: 'Positive',
  labelContaminado: 'Contaminated',
  geral_labelExportando: 'Exporting...',
  geral_labelSelecione: 'Select',
  geral_labelFILTRAR_EXPORTAR: 'FILTER AND EXPORT',
  btnRemoverFiltros: 'REMOVE FILTERS',
  modalAtualVersao_labelAvisoImportante: 'Important warning!',
  modalAtualVersao_labelVocêEstaUtilizandoVersaoAntiga: 'You are using an old version ',
  modalAtualVersao_labeljaEstaDisponivelNovaVersaoAplicativo: '. A new version of this application is now available',
  modalAtualVersao_labelCliqueBtnAtualApp: '. Click the "Update App" button to continue using its features.',
  modalAtualVersao_btnAtualizarApp: 'Update App',
  modalAtualVersao_btnAgoraNao: 'Not now',
  geral_modalCancelarOperacao: 'Operation will be cancelled. Do you really want to exit the flow?',
  geral_textoLeituraAutomaticaPlacaApresentacao: 'Automatic Reading of Results',
  geral_textoAgoraVocePodePlacaApresentacao001: 'Now you can count on ',
  geral_textoAgoraVocePodePlacaApresentacao002: 'to read your plates',
  geral_textoAgoraVocePodePlacaApresentacao003: 'automatically',
  geral_textoAgoraVocePodePlacaApresentacao004: 'She is ours',
  geral_textoAgoraVocePodePlacaApresentacao005: 'Artificial intelligence',
  geral_textoAgoraVocePodePlacaApresentacao006: ' and will bring several new features to make your day-to-day life easier.',
  geral_btnVerDicasFotografar: 'VIEW TIPS ON HOW TO TAKE PHOTOS',
  geral_btnAnexarFoto: 'ADD PHOTO',
  geral_btnProximaDica: 'VIEW NEXT TIP',
  geral_textoDica1Iluminacao001: 'Tip 1: Lighting!',
  geral_textoDica1Iluminacao002: 'Turn on the',
  geral_textoDica1Iluminacao003: 'local light',
  geral_textoDica1Iluminacao004: 'where the',
  geral_textoDica1Iluminacao005: 'Smartlab ',
  geral_textoDica1Iluminacao006: 'is installed and also ',
  geral_textoDica1Iluminacao007: 'cabin light',
  geral_textoDica1Iluminacao008: ' from SmartLab.',
  geral_textoDica1Iluminacao009: 'Good lighting helps to',
  geral_textoDica1Iluminacao010: 'highlight the colors',
  geral_textoDica1Iluminacao011: ' bacteria and ',
  geral_textoDica1Iluminacao012: 'facilitate',
  geral_textoDica1Iluminacao013: ' the correct recognition of the algorithm.',
  geral_labelInicieLançamento: 'Start a Release',
  labelNovaMastiteClinicaSemCultura: 'New clinical mastitis WITHOUT culture',
  labelSelecioneQuarto: 'Select Udder Quarter',
  geral_labelMoeda: '$',
  labelOuDigiteCodigoBarras: 'Or enter barcode',
  geral_labelLeituraPlacaUbere: 'Plate Reading - Udder',
  geral_labelLeituraPlacaBezerra: 'Plate Reading - Calf',
  geral_textoCompartilhar: 'Share treatment',
  geral_btnFinalizar: 'Finish',
  labelQuartoPE: 'LR',
  labelQuartoAE: 'LF',
  labelQuartoPD: 'RR',
  labelQuartoAD: 'RF',
  geral_ativarPopup: 'Enable Popup',
  geral_textoAtivarLeituraAutomDiag: 'Enable automatic diagnostic reading',
  labelLeituraEm: 'Reading in',
  geral_labelStatusMastiteClinica: 'Clinical Mastitis',
  geral_labelStatusMastiteSubClinica: 'Subclinical mastitis',
  geral_labelStatusMastiteSemCultura: 'Mastitis without culture',
  geral_textoDica2PlacaCentralizada001: 'Tip 2 Centralized Plate',
  geral_textoDica2PlacaCentralizada002: 'Place the plate in ',
  geral_textoDica2PlacaCentralizada003: 'Smartlab Reading Support',
  geral_textoDica2PlacaCentralizada004: ', and adjust it correctly and centrally, avoiding it being crooked.',
  geral_textoDica2PlacaCentralizada005: 'This can ',
  geral_textoDica2PlacaCentralizada006: 'get in the way of identification',
  geral_textoDica2PlacaCentralizada007: 'from which sample and stage there was growth.',
  geral_textoDica3AtencaoMarcacao001: 'Tip 3 Pay attention to marking',
  geral_textoDica3AtencaoMarcacao002: 'Approach',
  geral_textoDica3AtencaoMarcacao003: ' the cell phone camera so that the card is fitted ',
  geral_textoDica3AtencaoMarcacao004: 'according to markings',
  geral_textoDica3AtencaoMarcacao005: ' suggested.',
  geral_textoDica3AtencaoMarcacao006: 'The secret is the photo that exactly occupies the space in the marking',
  geral_textoDica3AtencaoMarcacao007: 'no leftovers',
  geral_textoDica3AtencaoMarcacao008: ' around',
  geral_textoDica3AtencaoMarcacao009: "Don't show tips again",
  labelNotificacoes: 'Notifications',
  geral_textNotificacaoRespQuestCuraCLinica: 'Answer Clinical Cure Questions',
  geral_textNotificacaoAtualizarVacasLactacao: 'Update Lactating Cows',
  geral_textNotificacaoPlaca: 'Plate ',
  geral_textNotificacaoProntaLeitura: 'ready to read',
  geral_traducao0001: 'We are processing the report, and it will soon be available for download in OnFarmApp Web notifications. Access the Link app.onfarm.com.br.',
  geral_traducao0002: 'Sorry, but there was an error generating the report.',
  geral_traducao0003: 'No internet connection',
  geral_traducao0004: 'Start date greater than end date.',
  geral_traducao0005: 'Disable popup',
  geral_traducao0006: 'Reply later',
  geral_traducao0007: 'Your answer',
  geral_traducao0008: 'Send',
  geral_traducao0009: 'The lump disappeared and never returned to this room',
  geral_traducao0010: 'CURED',
  geral_traducao0011: 'He came back or continued to be clumsy in this room',
  geral_traducao0012: "DON'T CURE",
  geral_traducao0013: 'It was discarded',
  labelSeca: 'Dry',
  geral_traducao0015: 'Next',
  geral_traducao0016: 'Confirmation',
  geral_traducao0018: 'View details',
  geral_traducao0019: 'Remove this treatment',
  geral_traducao0020: 'Add this treatment',
  geral_traducao0021: 'Start of treatment',
  labelIntramamario: 'Intramamary',
  labelAntiInflamatorio: 'Anti-inflammatory',
  labelInjetavel: 'Injectable',
  labelNaoDefinido: 'Undefined',
  geral_traducao0026: 'With the inclusion of a new treatment, all tasks from previous treatments that are open will be interrupted, would you like to proceed?',
  geral_traducao0027: 'Use this treatment',
  geral_traducao0028: 'Treatment added',
  labelLado: 'Side',
  labelPlaca: 'Plate',
  labelCriacao: 'Creation',
  geral_traducao0034: 'Update',
  geral_traducao0036: 'SmartStrep Test',
  geral_traducao0037: 'Agents',
  labelRealizarTratamento: 'Perform treatment?',
  geral_traducao0039: 'or',
  geral_traducao0040: 'Choose saved treatment',
  labelVerTodos: 'View all',
  labelAtivo: 'Active',
  labelInativo: 'Inactive',
  geral_traducao0044: 'There are no suggested treatments for this diagnosis',
  labelAguardando: 'Waiting',
  labelCurou: 'Cured',
  labelNaoCurou: "Didn't Heal",
  labelDescartado: 'Discarded',
  labelNaoAnalisado: 'Not analyzed',
  geral_traducao0052: 'Create new treatment',
  geral_traducao0053: 'No Data Found',
  labelCompartilhar002: 'SHARE',
  labelPrevalencaAgentes: 'Prevalence of agents',
  labelFrequenciaCrescimento: 'Growth frequency',
  geral_traducao0057: 'Animal history',
  geral_traducao0058: 'Cure Chance',
  geral_traducao0059: 'Average of your herd',
  geral_traducao0060: 'Diagnostic result',
  geral_traducao0061: 'Try later',
  geral_traducao0062: 'The report request has been sent to the server',
  geral_traducao0063: 'You will receive a notification when it is available.',
  geral_traducao0064: 'View calculation details',
  geral_traducao0066: 'High',
  geral_traducao0067: 'Low',
  geral_traducao0068: 'Read date',
  geral_traducao0069: 'Clinical Cure Confirmation',
  geral_traducao0070: 'Please enter the number of lactating cows this month to generate the clinical mastitis incidence calculation.',
  geral_traducao0071: 'With Growth',
  geral_traducao0072: 'No Growth',
  geral_traducao0073: 'JANUARY',
  geral_traducao0074: 'FEBRUARY',
  geral_traducao0075: 'MARCH',
  geral_traducao0076: 'APRIL',
  geral_traducao0077: 'MAY',
  geral_traducao0078: 'JUNE',
  geral_traducao0079: 'JULY',
  geral_traducao0080: 'AUGUST',
  geral_traducao0081: 'SEPTEMBER',
  geral_traducao0082: 'OCTOBER',
  geral_traducao0083: 'NOVEMBER',
  geral_traducao0084: 'DECEMBER',
  geral_traducao0085: 'Do you really want to extend the treatment?',
  geral_traducao0087: 'Try again later!',
  geral_traducao0088: ' is available for download, to access the report use the web application.',
  geral_traducao0089: 'The Report',
  geral_traducao0090: 'The protocol will be closed from the day',
  returnGostariaRealmenteInterromperTratamento: 'Would you really like to stop treatment?',
  geral_traducao0092: 'Invoices close to due date',
  geral_traducao0093: 'Ready plates',
  geral_traducao0094: 'Just a moment while I check our',
  geral_traducao0095: 'Not included',
  geral_traducao0096: 'Unrealized',
  geral_traducao0097: 'Report what happened to the ID',
  geral_traducao0098: 'referring to date',
  geral_traducao0099: 'database',
  geral_traducao0100: 'CONTINUE TASK',
  geral_traducao0101: 'INTERRUPT PROTOCOL',
  kabekPresencaGrumo: 'Presence of Lump',
  labelApliquei: 'I applied',
  labelNaoApliquei: "I didn't apply",
  labelSalvarDiagnostico: 'SAVE DIAGNOSIS',
  labelCuraClinicaPorTratamento: 'Clinical cure by treatment',
  labelDataInicial: 'Initial date',
  labelDataFinal: 'Final date',
  geral_traducao0109: 'CURE [YES]',
  geral_traducao0110: 'CURE [NO]',
  labelIntramariosMaisUtilizadosComunidade: 'Most Used Intramammary Antibiotics by the OnFarmers',
  labelInjetaveisMaisUtilizadosComunidade: 'Most Used Injectable Antibiotics by the OnFarmers',
  labelAntiflamatoriosMaisUtilizadosComunidade: 'Most Used Anti-inflammatory by the OnFarmers',
  labelDiasATBIntramamarioMaisUtilizadosComunidade: 'Most used intramammary ATB days by the OnFarmers community',
  labelCuraClinicaComunidade: 'Clinical Cure by the OnFarmers Community',
  labelIncidenciaMastiteComunidade: 'Incidence of Clinical Mastitis by the OnFarmers Community',
  geral_traducao0117: 'Barcode reader',
  geral_traducao0118: 'Test reading',
  geral_traducao0119: 'REGISTER PHOTO OF PLATE',
  geral_traducao0120: 'Open',
  labelCancelado: 'Cancelled',
  labelConcluida: 'Completed',
  labelAtrasada: 'Delayed',
  geral_traducao0124: 'and fourth',
  geral_traducao0125: 'and rooms',
  geral_traducao0126: 'Did you take the SmartStrep Test?',
  geral_traducao0127: 'Yes agalactiae',
  geral_traducao0128: 'Yes dysgalactiae',
  geral_traducao0129: 'January',
  geral_traducao0130: 'February',
  geral_traducao0131: 'March',
  geral_traducao0132: 'April',
  geral_traducao0133: 'May',
  geral_traducao0134: 'June',
  geral_traducao0135: 'July',
  geral_traducao0136: 'August',
  geral_traducao0137: 'September',
  geral_traducao0138: 'October',
  geral_traducao0139: 'November',
  geral_traducao0140: 'December',
  labelSelecioneTipoAmostra: 'Select sample type',
  geral_traducao0142: 'Mastitis Degree',
  geral_traducao0143: 'Select the side',
  labelMastiteClinicaGrumo: 'Clinical Mastitis (Grum)',
  geral_traducao0145: 'Subclinical mastitis(high SCC)',
  geral_traducao0146: 'Microbiological Tank Examination',
  geral_traducao0147: 'Are you sure you want to replace the Treatment? Open tasks for the current treatment will be stopped',
  geral_traducao0148: 'Do you really want to save this treatment?',
  geral_traducao0149: 'User not authorized for purchase.',
  geral_traducao0150: 'Post childbirth',
  labelQuantidadeOuPorcentagem: 'Quantity or Percentage',
  labelQuantidade: 'Quantity',
  labelPorcentagem: 'Percentage',
  geral_traducao0154: 'Degree',
  geral_traducao0156: 'Sum of Scores',
  geral_traducao0157: '4 or less',
  geral_traducao0158: 'greater than 6',
  geral_traducao0159: 'Pneumonia',
  geral_traducao0160: 'Diarrhea',
  geral_traducao0161: 'Date of birth',
  geral_traducao0162: 'Age',
  geral_traducao0163: 'Feces',
  geral_traducao0164: 'Nose',
  geral_traducao0165: 'Eye',
  geral_traducao0166: 'Was there growth?',
  geral_traducao0167: 'CONTINUE',
  geral_traducao0168: 'Select sample',
  labelLancamentoConcluidoSalveDiagnostico: 'Launch completed! Save your diagnosis',
  geral_traducao0170: 'Collection date',
  geral_traducao0171: "Cow's milk production(L)",
  geral_traducao0172: 'Average days of milk disposal when there is treatment (days)',
  geral_traducao0173: 'Price/liter of milk ($)',
  geral_traducao0174: 'Price/application ($)',
  geral_traducao0175: 'Number of applications/case of mastitis',
  geral_traducao0176: 'Light blue/greenish (3 or + colonies)',
  geral_traducao0177: 'Dark Blue Metallic (3 or + colonies)',
  geral_traducao0178: 'Dark Purple (3 or + colonies)',
  geral_traducao0179: 'Yellow/Greenish (3 or + colonies)',
  geral_traducao0180: 'Light blue-green (3 or + colonies)',
  geral_traducao0181: 'Dull gray-white (3 or + colonies)',
  geral_traducao0182: 'Creamy - Shiny (3 or + colonies)',
  geral_traducao0183: 'Purple/Wine (3 or + colonies)',
  geral_traducao0184: 'Indicate the color of the displayed colonies',
  geral_traducao0185: 'Other Gram-pos',
  geral_traducao0186: 'Prototheca/Yeast',
  geral_traducao0187: 'Staph non aureus',
  geral_traducao0188: 'Sample from the side',
  geral_traducao0189: 'Registered successfully!',
  geral_traducao0190: 'Want to register side',
  geral_traducao0192: 'Side Diagnosis',
  geral_traducao0193: "That doesn't usually take",
  geral_traducao0194: 'Select Degree',
  geral_traducao0195: 'Successfully saved!',
  geral_traducao0196: "You haven't yet defined a treatment for this case",
  geral_traducao0197: 'FOLLOW WITHOUT DEFINED A TREATMENT',
  geral_traducao0198: 'CHOOSE A TREATMENT',
  geral_traducao0199: 'Open the card cover and position it on the reading support',
  geral_traducao0200: 'Select a treatment protocol',
  geral_traducao0201: 'Inconsistency in the sent data, please try again later.',
  geral_traducao0202: 'Choose an option',
  geral_traducao0203: "Rumi's Tip",
  geral_traducao0204: 'Treatment Saved',
  geral_traducao0205: 'Access with Biometrics',
  geral_traducao0206: 'No treatment',
  geral_traducao0207: 'All',
  geral_traducao0208: 'Read date',
  geral_traducao0209: 'Choose Treatment',
  geral_traducao0210: 'Perform Treatment?',
  geral_traducao0211: 'Please select a treatment, or mark that you will not proceed with treatment.',
  geral_traducao0212: 'Remove',
  geral_traducao0213: 'Reprocess Reading?',
  geral_traducao0214: 'EXTEND PROTOCOL',
  labelDiario: 'Daily',
  labelMensal: 'Monthly',
  labelDiarioOuMensal: 'Daily Or Monthly',
  geral_traducao0218: 'Lactating Cows',
  geral_traducao0219: 'Incidence Qty',
  geral_traducao0220: 'Application periods',
  geral_traducao0221: 'Add Treatment',
  geral_traducao0222: 'INSERT NEW TREATMENT',
  geral_traducao0223: 'Tip from',
  geral_traducao0224: 'unavailable',
  geral_traducao0225: "Right now, Rumi's analysis for the",
  geral_traducao0226: 'Cure Chance Score',
  geral_traducao0227: 'is only available when reading Clinical Mastitis results',
  returnVoceEstaTentandoConcluirTarefaPrevista: 'You are trying to complete a task scheduled for ',
  returnDesejaMesmoMarcarTarefaConcluida: ' Do you really want to mark the task as completed?',
  geral_traducao0230: 'Diagnosis date',
  geral_traducao0231: 'Enter an ID',
  geral_traducao0232: 'Other Gram-neg',
  geral_traducao0233: 'Do you disagree with this result?',
  geral_traducao0234: 'Launch manually',
  geral_traducao0235: 'SAVE DIAGNOSIS SIDE',
  geral_traducao0236: 'Other colors (3 or + colonies)',
  geral_traducao0237: 'Pink (1 or + colonies)',
  geral_traducao0238: 'Light Pink (3 or + colonies)',
  geral_traducao0239: 'Store',
  geral_traducao0240: 'Points',
  labelAcessar: 'Access',
  geral_traducao0244: 'Read Results',
  geral_traducao0245: 'Get to know our product',
  geral_traducao0246: 'tank monitoring',
  geral_traducao0247: 'Learn more here',
  geral_traducao0248: 'Offered by',
  geral_traducao0249: 'Last update',
  geral_traducao0250: 'LID OPEN',
  geral_traducao0251: 'CHECK COMMUNICATION FAILURE',
  geral_traducao0252: 'CHECK SENSOR PROBLEM',
  geral_traducao0253: 'SKIP TUTORIAL',
  geral_traducao0254: 'Data in synchronization.',
  geral_traducao0255: 'If any information is missing, please wait for synchronization to finish and return to this screen shortly',
  geral_traducao0256: 'Internal error, please repair the database.',
  geral_traducao0257: 'Are you sure you want to reprocess the Diagnosis? There is a related treatment, open tasks will be stopped.',
  geral_traducao0258: 'Rumi offline - No internet connection',
  geral_traducao0259: 'Synchronize now',
  geral_traducao0260: 'data',
  labelCodigoBarras: 'Barcode',
  geral_traducao0262: 'Invalid barcode',
  geral_traducao0263: 'Barcode already used',
  geral_traducao0264: 'Edit the photo',
  geral_traducao0265: 'No Internet',
  geral_traducao0266: 'Access with biometrics',
  geral_traducao0267: 'Treatment period',
  geral_traducao0268: "RUMI'S TIP",
  geral_traducao0269: 'Hide',
  geral_traducao0270: 'DIVERGENCE OF RESULT',
  geral_traducao0271: 'I promise to get it right next time!',
  geral_traducao0272: 'Despite',
  geral_traducao0273: 'very high accuracy',
  geral_traducao0274: 'in my analysis of results, from time to time we may have some divergence!',
  geral_traducao0275: "But don't worry, you can make your diagnosis manually and our analysts will carry out a strict checking process.",
  geral_traducao0276: 'SET MANUAL DIAGNOSIS',
  geral_traducao0277: 'Results based on OnFarmers database.',
  geral_traducao0278: 'This is just a list of the treatments that had the highest potential chance of success according to the OnFarmers database.',
  geral_traducao0279: "For treatment recommendations, consult your veterinarian's opinion.",
  geral_traducao0280: 'Important the medications below are listed in order of use.',
  geral_traducao0281: 'No indications',
  geral_traducao0282: 'Show 4 more options',
  geral_traducao0283: 'Share with Veterinarian',
  geral_traducao0284: 'Digite uma descrição',
  geral_traducao0285: 'Bacterias da Diarréia',
  geral_traducao0286: 'Soro',
  geral_traducao0287: 'Teste de diarreia',
  geral_traducao0288: 'Teste de Tristeza',
  geral_traducao0289: 'Visualizar doença',
  geral_traducao0290: 'Data fim',
  geral_traducao0291: 'Data Inicio',
  geral_traducao0292: 'SALVAR DOENÇA',
  geral_traducao0293: 'Escore olho',
  geral_traducao0294: 'Secreção Nasal',
  geral_traducao0295: 'Imagem indisponível',
  geral_traducao0296: 'Temperatura retal',
  geral_traducao0297: 'Data cura clínica',
  geral_traducao0298: 'Brinco Bezerra',
  geral_traducao0299: 'Nova doença',
  geral_traducao0300: 'Não foi realizada analise de cultura',
  geral_traducao0301: 'Ops, parece que há algo errado com a sua ',
  geral_traducao0302: 'conexão',
  geral_traducao0303: 'Rumi',
  geral_traducao0304: ' está tentando acessar os servidores para realizar a leitura mas não está conseguindo.',
  geral_traducao0305: 'Isso pode acontecer quando sua ',
  geral_traducao0306: ' com a internet está  ',
  geral_traducao0307: 'instável ou inexistente',
  geral_traducao0308: 'Ops, parece que há algo errado com ',
  geral_traducao0309: 'nossos servidores',
  geral_traducao0310: ' está tentando acessar os servidores para realizar a leitura mas não está conseguindo.',
  geral_traducao0311: 'Isso pode acontecer quando existe alguma instabilidade do ',
  geral_traducao0312: 'lado de cá',
  geral_traducao0313: 'Mas não se preocupe, já estamos investigando o que pode ter acontecido e resolveremos o ',
  geral_traducao0314: 'mais breve',
  geral_traducao0315: ' possível.',
  btnTentarNovamente: 'TENTAR NOVAMENTE',
  geral_traducao0317: 'FAZER DIAGNÓSTICO MANUAL',
  geral_traducao0318: 'Doses',
  returnRumiNaoProcessada: 'Rumi unprocessed, please reprocess reading.',
  labelChanceCura: 'CHANCE OF CURE',
  labelRegistrado: 'registered',
  returnValidacaoCognitoEmailSenha: 'Incorrect email and/or password.',
  labelAgentSiglaAg: 'Dys',
  labelHoje: 'Today',
  labelAtrasadas: 'Overdue',
  labelAbertas: 'Open',
  labelConcluidas: 'Completed',
  labelCanceladas: 'Cancelled',
  labelDias: 'days',
  labelOu: 'or',
  labelMeses: 'Months',
  labelAindaNaoTemDados: 'No data yet',
  labelExportar: 'Export',
  labelRelatóriosProcessados: 'Processed Reports',
  labelCasosMastiteTratamentosDia: 'Mastitis Cases and Treatments per Day',
  returnDesejaMesmoEditar: 'Do you really want to edit the ',
  returnDesejaMesmoEditarLancamentoMastite: 'mastitis release?',
  labelFechar: 'Close',
  labelSelecioneUmLado: 'Select a Side',
  labelDigiteCodigoBarras: 'Enter a barcode',
  labelDataExame: 'Exam Date',
  labelDataLeitura: 'Reading Date',
  labelVerificando: 'Checking',
  labelRevisarLeituraAutomatica: 'Review Automatic Readings',
  labelLancamentos: 'Releases',
  labelExameMicrobiologicoLancamentoLote: 'Microbiological Examination Batch Launch',
  returnDesejaMesmo: 'Do you really want to',
  returnRemoveResultado: 'remove the result?',
  returnDadosSalvoSucesso: 'Data saved successfully!',
  returnOcorreuErroSalvarDadosTenteNovamente: 'An error occurred while saving data, please try again!',
  labelConfirmarSenha: 'Confirm Password',
  labelAlterar: 'Change',
  labelAlterando: 'Changing',
  returnCamposObrigatorios: 'Fields are mandatory',
  returnSenhaInferiorDigitos: 'Password less than 6 digits',
  returnSenhasDiferentes: 'Passwords do not match',
  labelTipoDocumento: 'Document type',
  labelValor: 'Value',
  labelNumeroDocumentoFiscal: 'Tax document number',
  labelNenhumItem: 'No item',
  labelDataVencimento: 'Due date',
  labelDocumento: 'Document',
  labelAcompanheEntrega: 'TRACK DELIVERY',
  labelCopiarCodigoRastreamento: 'COPY TRACKING CODE',
  labelQuantidadePlacas: 'Qty. Plates',
  labelSemCodigoRastreio: 'No tracking code',
  returnJaExisteLancamento: 'There is already a record of Lactating Cows, do you want to replace it?',
  labelSelecioneData: 'Please select the date',
  returnDigiteQuantidadeValida: 'Please enter a valid quantity',
  labelSelecioneFazenda: 'Select the farm',
  labelSelecionePerfil: 'Select the profile',
  labelSelecioneTipo: 'Select the type',
  labelSelecioneCategoria: 'Select the category',
  labelTutoriais: 'Tutorials',
  labelIntegracaoParceiros: 'Partner Integration',
  labelHabilitar: 'Enable',
  labelIdentificacaoFazenda: 'Farm Identification',
  labelDataLacamento: "Release Date",
  labelLerCodigoBarras: "SCAN BARCODE",
  labelCodigoRegistrado: "REGISTERED CODE",
  labelDescricaoTanque: "Tank Description",
  returnFavorImagemAntesSelecionar: "Please attach the image before selecting the colony counting mode",
  returnTanqueSalvoSucesso: 'Tank saved successfully',
  labelOpcional: 'Optional',
  labelMinimo9Digitos: 'Minimum of 9 digits',
  labelDia: "Day",
  labelAberta: "Open",
  labelCancelada: "Canceled",
  labelAdicionar: "Add",
  labelSelecionarMedicamento: "Select the medication",
  labelPeriodosAplicacao: "Application periods",
  labelConcluirTratamento: "COMPLETE TREATMENT",
  labelConcluirTarefas: "COMPLETE TASKS",
  labelInterromperTratamento: "INTERRUPT TREATMENT",
  labelEstenderTratamento: "EXTEND TREATMENT",
  labelInformeAplicou: "Inform if you applied the ",
  labelInformeHouvePresencaGrumo: "Inform if there was the presence of clumps.",
  labelTratamentoSeraEncerradoPartirDia: "The treatment will be terminated starting from the day",
  labelDe: "of",
  returnDesejaMesmoInterromperTratamento: "Do you really want to interrupt the treatment?",
  returnDesejaMesmoExtenderTratamento: "Do you really want to extend the treatment?",
  labelRealizarTarefa: "Perform task",
  labelAtiveDesativeNotificacoes: 'Turn notifications on or off',
  returnFavorAguardeProcessamento: 'Please Wait For Processing.',
  returnFavorInserirDigitosPlaca: 'Please Enter The 9 Digits Of The Plate.',
  returnColostroCriadoSucesso: 'Colostrum Successfully Created.',
  returnCampoObrigatorio: 'Mandatory Field.',
  returnBrincoCampoObrigatorio: 'Ear Tag Is A Mandatory Field.',
  returnCampoBrincoNaoPodeFicarVazio: 'The Ear Tag Field Cannot Be Empty.',
  returnPorFavorSelecioneTratamento: 'Please Select A Treatment.',
  returnTemCertezaDesejaSubstituirTratamentoTarefasAbertoTratamentoAtualSeraoInterrompidas: 'Are You Sure You Want To Replace The Treatment? Open Tasks For The Current Treatment Will Be Interrupted.',
  returnTemCertezaDesejaSubstituirTratamentoTarefasAbertoSeraoInterrompidas: 'Are You Sure You Want To Replace The Treatment? Open Tasks Will Be Interrupted.',
  returnTemCertezaDesejaRemoverTratamentoTarefasAbertoSeraoInterrompidas: 'Are You Sure You Want To Remove The Treatment? Open Tasks Will Be Interrupted.',
  returnTemCertezaDesejaExcluirTratamentoTarefasRelacionadasSeraoExcluidas: 'Are You Sure You Want To Delete The Treatment? Related Tasks Will Also Be Deleted.',
  returnFavorSelecionePeloMenosMedicamento: 'Please Select At Least One Medication.',
  returnFavorSelecioneIntervaloAplicacao: 'Please Select An Application Interval.',
  returnFavorSelecioneTratamentoNaoAtivo: 'Please Indicate Whether The Treatment Is Active Or Not.',
  returnFavorSelecioneBacteria: 'Please Select The Bacteria.',
  returnErroProcessarRelatorioTenteNovamenteMaisTarde: 'Error While Processing Report, Please Try Again Later.',
  returnCompartilhamentoRealizadoSucesso: 'Sharing Successfully Completed.',
  returnHouveFalhaNaoFoiPossivelProcessarCompartilhamentoTenteMaisTarde: 'There Was An Error And Sharing Could Not Be Processed, Please Try Again Later.',
  returnFavorPreenchaTodosCampos: 'Please Fill In All Fields.',
  returnErroComunicarOmie: 'Error Communicating With Omie.',
  returnVoceNaoInformouNomeUsuario: 'You Did Not Provide The Users Name.',
  returnVoceNaoInformouLoginUsuario: 'You Did Not Provide The Users Login.',
  returnVoceNaoInformouFazenda: 'You Did Not Provide The Farm.',
  returnVoceNaoInformouPerfilUsuario: 'You Did Not Provide The Users Profile.',
  returnVoceNaoInformouTelefoneEnviaremosSenhaNumeroInformado: 'You Did Not Provide The Phone Number. The Password Will Be Sent To The Provided Number.',
  returnTelefoneInvalido: 'Invalid Phone Number!',
  returnUsuarioJaEstaEmUso: 'User Is Already In Use.',
  returnVoceDigitouCodigoDeBarrasEleDeveTerMinimoDigitos: 'You Entered The Barcode, It Must Be At Least 9 Digits.',
  returnDescricaoTanqueObrigatoria: 'Tank Description Is Mandatory.',
  returnVoceJaLancou: 'You Have Already Launched.',
  returnEtapasDesejaContinuarLancamento: '3 Steps, Do You Want To Continue The Launch?',
  returnInformeHouveCrescimento: 'Indicate Whether There Was Growth.',
  returnInformeCorColoniaObsPlacaConsulteGuiaCores: 'Indicate The Color Of The Colony Observed On The Plate. Refer To The Color Guide.',
  returnArquivoEnviadoComSucesso: 'File Successfully Uploaded!',
  returnHouveErroImportarArquivoTenteNovamenteMaisTarde: 'There Was An Error Importing The File, Please Try Again Later!',
  returnNecessarioSelecionarArquivo: 'You Need To Select A File.',
  returnVoceSelecionouMastiteClinicaPorFavorSelecioneTambemGrau: 'You Selected Clinical Mastitis, Please Also Select The Grade.',
  returnPorFavorInformeCodigoBarrasComDigitos: 'Please Provide The Barcode With 9 Digits.',
  returnPorFavorInformeBrincoAnimal: 'Please Provide The Animals Ear Tag.',
  returnSelecioneQuarto: 'Select The Quarter.',
  returnEssaPlacaFoiUtilizadaParaLadoAE: 'This Plate Has Already Been Used For Side [A] And.',
  returnPorFavorVerifiqueSeNaoDeixouNenhumCampoBranco: 'Please Check If You Left Any Field Blank.',
  returnInformacoesDiagnostico: 'Diagnosis Information.',
  returnANaoEncontradas: 'Not Found.',
  returnFavorSelecioneMedicamento: 'Please Select The Medication.',
  returnFavorSelecionePeloMenosBacteria: 'Please Select At Least One Bacteria.',
  returnFavorSelecionePeloMenosGrau: 'Please Select At Least One Grade.',
  returnFavorSelecionePeloMenosObs: 'Please Select At Least One Observation.',
  returnSelecioneAoMenosFazenda: 'Select At Least One Farm.',
  returnTemCertezaQueDesejaReprocessarOResultadoAgentesInformadosAnteriormenteSeraoExcluidos: 'Are You Sure You Want To Reprocess The Result? Previously Entered Agents Will Be Deleted.',
  returnVoceNaoSelecionouNenhumaFazenda: 'You Have Not Selected Any Farm.',
  returnCompartilhamentoRealizadoComSucesso: 'Sharing Successfully Completed.',
  returnDesejaExcluirResultado: 'Do you want to delete the result?',
  labelFoto: 'Photo',
  returnDesejaAssociarTratamentoNovaDoenca: 'Do you want to associate a treatment with this new disease?',
  labelDeletar: 'Delete',
  labelAnexarFotoPlaca: 'ATTACH PHOTO OF THE PLATE'
}
